<script>
import { sDs } from "@common/sDs/sDs.js";
import { componentStore } from "@common/componentStore/componentStore.js";
import { library } from "@common/library/library";

const buildInfoCfg = {
    cId: "buildInfo",
    cType: "buildInfo",
    cTitle: "Build Number",
    cTemplate: `<div :id="cId">{{buildInfo}}</div>`
};

const editorConfig = {
    showSubbuild: {
        type: 'boolean',
        label: 'Show Sub-Build'
    },
    showDate: {
        type: 'boolean',
        label: 'Show Date'
    },
    showInstance: {
        type: 'boolean',
        label: 'Show Instance'
    },
    showRole: {
        type: 'boolean',
        label: 'Show Role'
    },
    editorDescription: { type: "INFO", text: "The buildInfo component displays the build information for our current product environment. There are no settings to modify." },
    DocumentationUrl: { type: "URL", text: "Build Info Documentation", url: "https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/473464857/buildInfo" }
};

const buildInfoCmp = {
    name: 'buildInfo',
    editorSettings: editorConfig,
    props: {
        disableSessionStorage: {
            default: false
        }
    },
    data() {
        return {
            buildInfo: null,
            editorSettings: editorConfig
        };
    },
    methods: {
        onLoad() {
            let showSubbuild = true;
            let showDate = false;
            let showInstance = true;
            let showRole = false;
            if (typeof this.config !== 'undefined') {
                if (typeof this.config.showSubbuild !== 'undefined') {
                    showSubbuild = this.config.showSubbuild;
                }
                if (typeof this.config.showDate !== 'undefined') {
                    showDate = this.config.showDate;
                }
                if (typeof this.config.showInstance !== 'undefined') {
                    showInstance = this.config.showInstance;
                }
                if (typeof this.config.showRole !== 'undefined') {
                    showRole = this.config.showRole;
                }
            }
            if (!this.disableSessionStorage && library.getSessionStorage('buildInfo')) {
                this.buildInfo = library.getSessionStorage('buildInfo');
            } else {
                this.sDs.post("er_getBuild", showSubbuild, showDate, showInstance, showRole).then((response) => {
                    if (response.status === 'success') {
                        if (!this.disableSessionStorage) {
                            library.setSessionStorage('buildInfo', response.data);
                        }
                        this.buildInfo = response.data;
                    }
                });
            }
        },
    }
};

componentStore.initComponent(buildInfoCmp, buildInfoCfg, '@common/buildInfo.vue');
export { buildInfoCfg, buildInfoCmp };
export default buildInfoCmp;
</script>
